export const EventStatusConstants = {
  PENDING: {
    text: 'Pending',
    bgColor: 'bg-yellow-500',
    textColor: 'text-black'
  },
  STARTED: {
    text: 'Started',
    bgColor: 'bg-blue-500',
    textColor: 'text-white'
  },
  COMPLETED: {
    text: 'Completed',
    bgColor: 'bg-teal-500',
    textColor: 'text-white'
  },
  CLOSED: {
    text: 'Closed',
    bgColor: 'bg-green-500',
    textColor: 'text-white'
  },
  ENDED: {
    text: 'Ended',
    bgColor: 'bg-red-500',
    textColor: 'text-white'
  }
}; 